// ** React Imports
import { Fragment, useState ,useEffect} from "react";

// ** MUI Components
import {
  Avatar,
  Stepper,
  StepLabel,
  IconButton,
  Button,
  Box,
  Typography,
  Card,
  CardContent,
  CardHeader,
  CardActions,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  InputAdornment,
  CircularProgress,
  Popover,
  Drawer,
  Paper,
  Select,
  FormHelperText,
  Tabs,
  Tab,
} from "@mui/material";
import Radio from "@mui/material/Radio";
import MuiStep from "@mui/material/Step";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import Checkbox from "@mui/material/Checkbox";
import { styled, useTheme } from "@mui/material/styles";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import Tooltip from "@mui/material/Tooltip";
import AvatarGroup from "@mui/material/AvatarGroup";
import Collapse from "@mui/material/Collapse";
import {
  DataGrid,
  GridActionsCellItem,
  GridToolbarContainer,
} from "@mui/x-data-grid";

// ** Icon Imports
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import CloseIcon from "@mui/icons-material/Close";
import StarIcon from "@mui/icons-material/Star";
import StarOutlineIcon from "@mui/icons-material/StarOutline";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import ClearIcon from "@mui/icons-material/Clear";
import Icon from "../../../components/icon";

// ** Custom Component Imports
import StepperCustomDot from "../../../components/Stepper/StepperCustomDot";
import CustomAvatar from "../../../components/mui/avatar";
import CustomTextField from "../../../components/mui/text-field";
import CustomChip from "../../../components/mui/chip";
import CustomAutocomplete from "../../../components/mui/autocomplete";
import { stateNames , expandStateName} from "../../../components/US_StatesNames";

// ** Dialog Component Imports
import AddContactDialog from "./AddContact";
import AddPropertyAreaDialog from "./AddPropertyArea";
import AddEmployeeDoodle from "images/AddEmployeeDoodle.png";

// ** Utils Import
import { hexToRGBA } from "../../../components/utils/hex-to-rgba";

// ** Styled Component
import StepperWrapper from "../../../components/styles/mui/stepper";

import JobsiteAttachment from "./JobsiteAttachment";
import { SaveJobsite } from "../logic/SaveJobsite";
import { SaveAttachments } from "../../../components/logic/SaveAttachments";
import { DeleteContact } from "../logic/DeleteContact";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { DeleteProperty } from "../logic/DeleteProperty";
import { SaveAlert } from "../logic/SaveAlert";
import { GetAlerts } from "../logic/GetAlerts";
import { DeleteAlert } from "../logic/DeleteAlert";
import { Await } from "react-router-dom";
import { renderFilePreview } from "components/FilePrivews";
import { SavePropertyArea } from "../logic/SavePropertyArea";
import { useJobsitePermission } from "../permissions/JobsitePermissions";
import { usePropertyAreaPermission } from "../permissions/PropertyAreaPermissions";

const StepperHeaderContainer = styled(CardContent)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    borderRight: 0,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
}));

const Step = styled(MuiStep)(({ theme }) => ({
  "& .MuiStepLabel-root": {
    paddingTop: 0,
  },
  "&:not(:last-of-type) .MuiStepLabel-root": {
    paddingBottom: theme.spacing(6),
  },
  "&:last-of-type .MuiStepLabel-root": {
    paddingBottom: 0,
  },
  "& .MuiStepLabel-iconContainer": {
    display: "none",
  },
  "& .step-subtitle": {
    color: `${theme.palette.text.disabled} !important`,
  },
  "& + svg": {
    color: theme.palette.text.disabled,
  },
  "&.Mui-completed .step-title": {
    color: theme.palette.text.disabled,
  },
}));

const StepJobsite = styled(MuiStep)(({ theme }) => ({
  "& .MuiStepLabel-root": {
    paddingTop: 0,
  },
  "& .MuiStepLabel-iconContainer": {
    display: "none",
  },
  "& .step-subtitle": {
    color: `${theme.palette.text.disabled} !important`,
  },
  "& + svg": {
    color: theme.palette.text.disabled,
  },
  "&.Mui-completed .step-title": {
    color: theme.palette.text.disabled,
  },
}));

const TabPanel = ({ children, value, index, ...other }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`jobsite-tabpanel-${index}`}
      aria-labelledby={`jobsite-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
};

const AddJobsiteDialog = ({ 
  open, 
  setJobsiteOpen,
  handleClose ,
  customer,
  fetchContactData,
  toast,
  jobsite,  
  handleJobsiteChange,  
  navigate,
  NProgress,
  fetchContacts,
  contacts,
  propertyArea,
  setPropertyArea,
  areaMeasurement, 
  setAreaMeasurement,
  setLoading,
  fetchJobsites,
  activeStep,
  setActiveStep,
  clearAreaMeasurement,
  fetchPropertyArea,
  propertyAreaList ,
  clearPropertyArea,
  jobsiteContent,
  alertList, 
  setAlertList,
  files,
  setFiles,
}) => {

  //#region Permissions
  const { JobsitePermissionProps } = useJobsitePermission();
  const {
    hasAlertGetPermission,
    hasAlertSavePermission,
    hasAlertDeletePermission,
  } = JobsitePermissionProps;

  const { PropertyAreaPermissionProps } = usePropertyAreaPermission();
  const {
    hasPropertyAreaSavePermission,
    hasPropertyAreaGetPermission,
    hasPropertyAreaDeletePermission,
  } = PropertyAreaPermissionProps;
  //#endregion Permissions

  // ** Hooks
  const theme = useTheme();

  // ** States
  const initialAlert = {
    alertID: 0,
    jobsiteID: 0,
    alertDescription: null,
    isActive: true
  }
  const [alert, setAlert] = useState(initialAlert);
  const [tabValue, setTabValue] = useState(0); // For tabbed mode

  const [checkedContacts, setCheckedContacts] = useState({});
  const [propertyAreaIsEmpty, setPropertyAreaIsEmpty] = useState(false);
  const [openPropArea, setOpenPropArea] = useState(false);
  
  const [openPropAreaOutdoor, setOpenPropAreaOutdoor] = useState(false);

  const [propertyContent, setPropertyContent] = useState({title:"Create Property Area" , mode:'create'});

  const [openNewPropertyDlg, setOpenNewPropertyDlg] = useState(false);
  const [openNewContactDlg, setOpenNewContactDlg] = useState(false);
  

  const [openUploadDlg, setOpenUploadDlg] = useState(false);
  const [uploadFiles, setUploadFiles] = useState([]);
  
  const [isJobsiteCompleted, setIsJobsiteCompleted] = useState(false);
  const [errors, setErrors] = useState({});

  const [Indoor, setIndoor] = useState();
  const [Outdoor, setOutdoor] = useState();   

  const [activeAlerts, setActiveAlerts] = useState([]);
  const [inactiveAlerts, setInactiveAlerts] = useState([]);
  
  const [alertErrors, setAlertErrors] = useState([]);

  const MySwal = withReactContent(Swal);

  const [listOfMeasurements, setListOfMeasurements] = useState([]);

  const [searchContactText, setSearchContactText] = useState('');
  const [searchPropAreaText, setSearchPropAreaText] = useState('');

  // Define tabs for tabbed mode
  const tabs = [
    {
      label: "Jobsite Details",
      value: 0,
    },
    {
      label: "Jobsite Contacts",
      value: 1,
    },
    ...(hasPropertyAreaSavePermission ? [{
      label: "Property Areas",
      value: 2,
    }] : []),
    ...(hasAlertSavePermission ? [{
      label: "Jobsite Alerts",
      value: 3,
    }] : []),
  ];

  const steps = [
    {
      title: "Jobsite Details",
    },
    {
      title: "Jobsite Contacts",
    },
    {
      title: "Property Areas",
    },
    {
      title: "Jobsite Alerts",
    },
  ];

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  // Rest of your existing functions remain the same...
  const handleCloseUploadDlg = () => {
    if(uploadFiles.length > 0){
      MySwal.fire({
        title: 'Are you sure?',
        html: "Any unsaved changes will be discarded. Do you want to proceed?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#23A26D',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Proceed!',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.isConfirmed) {
          setUploadFiles([]);
          setOpenUploadDlg(false); 
        }
      });  
     }else{
        setUploadFiles([]);
        setOpenUploadDlg(false); 
     }  
  };

  const handleAlertChange = (field, value) => {
    let tempErrors = {};
    if(field === 'alertDescription' && !value){
      tempErrors.alertDescription = "Alert description cannot be empty";   
    }
    setAlertErrors(tempErrors);
    setAlert((prev)=>({...prev, [field]:value,}))
  }

  const handleAlertEdit = async (id) => {    
    let getAlert = alertList.filter(x => x.alertID === id)[0];
    getAlert.isActive = !getAlert.isActive;    
    handleSaveAlert(getAlert,true);
  }

  const handleSaveAlert = async (data = 0, isEditing = false) => {
    if(alert.alertDescription || isEditing)
    {
      setLoading(true);
      try {        
        const result = await SaveAlert(isEditing? data : alert,navigate);
        if (result && !result.isError) {
         if(!isEditing){
          handleAlertChange('alertDescription' , '');
          handleAlertChange('alertID' , 0);
          handleAlertChange('isActive' , true);
         } 
          fetchAlerts();
          toast.success(!isEditing? result.message : 'Jobsite alert updated successfully.', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
          });
        }else{
          setAlertErrors({alertDescription:result.message});          
        }
      } catch (error) {
        console.error('Error saving alert:', error);              
      }finally{
        setLoading(false);
      } 
    }else if(!alert.alertDescription && !isEditing){
      setAlertErrors({alertDescription:'Alert description cannot be empty.'});
    }
  }

  const fetchAlerts = async() =>{
    try {
      setLoading(true);
      let alrts = await GetAlerts(jobsite.jobsiteID,0,navigate);      
      setAlertList(alrts);
      setActiveAlerts(alrts.filter(x => x.isActive));
      setInactiveAlerts(alrts.filter(x => !x.isActive));      
    } catch (error) {
      console.error("Error fetching Alerts data:", error);
    } finally {
      setLoading(false);
    }
  }

  const handleContactDelete = async () => {
    setCheckedContacts({});
  };  

  const handleSaveJobSite = async () => {
    const result = await SaveJobsite(jobsite, navigate);
    console.log(jobsite)
    console.log(result)
    
    if (result.success) {
      console.log("Jobsite saved successfully:", result.data);
      handleJobsiteChange("jobsiteID", result.data.jobsiteID);
      if (files.length > 0 && activeStep === 0) {
        HandleAttachments(result.data.jobsiteID);
      }
      fetchJobsites();
      if(jobsiteContent.mode === 'edit' || jobsiteContent.mode === 'tabbed'){
        toast.success(`"${jobsite?.jobsiteName}" ${jobsiteContent?.notification}`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
        });
        setJobsiteOpen(false);
      }
      return true;
    } else {
      console.error("Error saving jobsite:", result.error);
      toast.error(result.error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
      });
      if(result.error.includes('Jobsite')){
        setErrors({ jobsiteName: 'Jobsite name already exists' })
      }
      return false;
    }
  };

  const handleEditPropertyArea = (id) =>{
    let Property = propertyAreaList.filter(x => x.propertyAreaID === id)[0];
    setPropertyArea(Property); 
    setListOfMeasurements(Property.measurement);
    setPropertyContent({title:"Edit Property Area" , mode:'edit'});
    setOpenNewPropertyDlg(true);
    fetchPropertyArea(Property.jobsiteID,0);
  };

 const handleDeletePropertyArea = (id, jobsiteID) => {
  MySwal.fire({
    title: '<strong>Are you sure?</strong>',
    html: "<span>You won't be able to revert this!</span>",
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, keep it',
    width: '390px',
    padding: '1rem',
    focusConfirm: false,
    showCloseButton: true,
    closeButtonHtml: '&times;',
    customClass: {
     popup: theme.palette.mode === 'dark' ? 'custom-swal-popup-dark' : 'custom-swal-popup',
          title: theme.palette.mode === 'dark' ? 'custom-swal-title-dark' : 'custom-swal-title',
          htmlContainer: 'custom-swal-html',
          confirmButton: 'custom-swal-confirm',
        cancelButton: theme.palette.mode === 'dark' ? 'custom-swal-cancel-dark' : 'custom-swal-cancel',
          closeButton: 'custom-swal-close'
    }
  }).then(async (result) => {
    if (result.isConfirmed) {
      setLoading(true);      
      try {
        const response = await DeleteProperty(id, jobsiteID, navigate);        
        if (response && !response.isError) { 
          fetchPropertyArea(jobsiteID, 0); 
          toast.success(response.message || `Property area deleted successfully.`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
          });
        } else {                       
          toast.error(response.message || 'Failed to delete the Property area.', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
          });
        }
      } catch (error) {
        console.error('Error deleting Property area:', error);      
      } finally {
        setLoading(false);
      }
    }
  });
};

  const handleAlertDelete = async (id,jobsiteID ) =>{
    setLoading(true);      
      try {
        const result = await DeleteAlert(id,jobsiteID,navigate);        
        if (result && !result.isError) { 
          fetchAlerts(); 
          toast.success(result.message || `Jobsite alert deleted successfully.`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
            });
        } else {                       
          toast.error(result.message || 'Failed to delete the Jobsite alert.', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
          });
        }
      } catch (error) {
        console.error('Error deleting Jobsite alert:', error);      
      }finally {
        setLoading(false);
    } 
  }

  const HandleAttachments = async (jobsiteID) =>{    
    for(var i = 0; i<files.length; i++){
      NProgress.start();
      const file = files[i]; 
      if (!file) {              
        return;
      }    
      const formData = new FormData();
      formData.append('file', file);                  
      formData.append('FileName', file.name);          
      formData.append('EntityType', 'Jobsite');       
      formData.append('EntityID', jobsiteID);      
      formData.append('MediaType', 'Attachment');      
      try {
        let data = await SaveAttachments(formData,navigate); 
        if (data && !data.isError) { 
          // Success handling
        } else {                  
          toast.error(data.message || 'Failed to upload the file.', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
            });
        }
      } catch (error) {
        console.log('An error occurred while uploading the file. Please try again.');
      }finally{
        NProgress.done();
      } 
    }            
  };

  useEffect(() =>{
    if(propertyAreaList.length > 0){
      setIndoor(propertyAreaList?.filter(x => x.propertyAreaType === 'Indoor'));
      setOutdoor(propertyAreaList?.filter(x => x.propertyAreaType === 'Outdoor'));
    }    
  },[propertyAreaList]);

  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      const timer = setTimeout(() => {
        setErrors({});
      }, 6000);
      return () => clearTimeout(timer);
    }
  }, [errors]);

  useEffect(() => {   
      const selectedContacts = Object.entries(checkedContacts || [])
        .filter(([key, value]) => !isNaN(key) && value) 
        .map(([key, value]) => ({ contactID: key, isPrimary: true }));
  
      if (selectedContacts.length > 0) {        
        handleJobsiteChange("contact", selectedContacts);
      }       
  }, [checkedContacts]); 

  useEffect(()=>{
    handleAlertChange('jobsiteID',jobsite?.jobsiteID);    
  },[jobsite])

  // Pre-select contacts when dialog opens in edit mode
  useEffect(() => {
    if (open && jobsite?.contact && Array.isArray(jobsite.contact) && jobsite.contact.length > 0 && contacts && contacts.length > 0) {
      displayCurrentContacts();
    }
  }, [open, jobsite?.contact, contacts]);

  const displayCurrentContacts = () => {   
    updateCheckedContacts(jobsite.contact, contacts);            
  }

  const updateCheckedContacts = (jobsiteContacts, allContacts) => {
    const updatedCheckedContacts = {};

    const jobsiteContactIDs = jobsiteContacts.map(contact => parseInt(contact.contactID));

    allContacts.forEach((contact) => {
      updatedCheckedContacts[contact.id] = jobsiteContactIDs.includes(parseInt(contact.id));
    });
    setCheckedContacts(updatedCheckedContacts);
  };

  const handleNext = async () => {
    if (validateFields(activeStep)) {
      NProgress.start();        
      try {
          if(jobsiteContent.mode === 'edit'){
            const nextStep = await setActiveStep((prevActiveStep) => prevActiveStep + 1);
            return nextStep;
          }else{
            if (activeStep === 0) {
              const result = await handleSaveJobSite();
              if (result) {
                if (jobsite?.contact?.length > 0) {
                  displayCurrentContacts();
                }
                fetchPropertyArea(jobsite.jobsiteID, 0);
                setActiveStep((prevActiveStep) => prevActiveStep + 1);
              }
            } else if (activeStep === 1) {
              const result = await handleSaveJobSite();
              if (result) {
                setActiveStep((prevActiveStep) => prevActiveStep + 1);
              }
            } else if (activeStep === 2) {
              fetchAlerts();
              fetchPropertyArea(jobsite.jobsiteID, 0);
              setActiveStep((prevActiveStep) => prevActiveStep + 1);
            } else if (activeStep === steps.length - 1) {
              setIsJobsiteCompleted(true);
              setCheckedContacts({});
              toast.success(`"${jobsite?.jobsiteName}" ${jobsiteContent?.notification}`, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
              });
              setJobsiteOpen(false);
              if(propertyAreaList.length === 0){
                handleSaveProperty();
              }
            }
          }
      } catch (error) {
        console.error("Error:", error);
      } finally {
        NProgress.done();
      }
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSaveProperty = async () => {   
    let propArea = {
      "propertyAreaID": 0,
      "jobsiteID": jobsite?.jobsiteID,              
      "propertyAreaType": 'Indoor',
      "propertyAreaName": jobsite?.jobsiteName,
      "description":  jobsite?.street1 || '',
      "measurement": []
    }           
    try {            
      let data = await SavePropertyArea(propArea,navigate,jobsite?.jobsiteID)       
      if (data && !data.isError) {
        fetchPropertyArea(jobsite?.jobsiteID,0);      
      }
    } catch (error) {
      console.log('An error occurred while saving property. Please try again.');
    }finally{
    }
  }

  const handleAvatarClick = (item) => {
    setCheckedContacts((prevCheckedContacts) => ({ 
      ...prevCheckedContacts,
      [item]: false,
    }));
  };

  const handleOpenNewPropertyDlg = () => {
    clearPropertyArea();
    setListOfMeasurements([]);
    clearAreaMeasurement();
    setPropertyContent({title:"Create Property Area" , mode:'create'});
    setOpenNewPropertyDlg(true);
  };

  const handleCloseNewPropertyDlg = () => {    
    setOpenNewPropertyDlg(false);
  };

  const handleClickPropArea = (index,value) => {    
    setOpenPropArea((prev) => ({        
      ...prev,
      [index]: !value,
    }));
  };

  const handleClickPropAreaOutdoor = (index,value) => {    
    setOpenPropAreaOutdoor((prev) => ({        
      ...prev,
      [index]: !value,
    }));
  };

  const handleOpenNewContactDlg = () => {
    setOpenNewContactDlg(true);
  };

  const handleCloseNewContactDlg = () => {
    setOpenNewContactDlg(false);
  };
  
  const handleOpenUploadDlg = () => {
    setOpenUploadDlg(true);   
  };

  const handleToggleContacts = (item) => {
    setCheckedContacts((prevCheckedContacts) => ({
      ...prevCheckedContacts,
      [item]: !prevCheckedContacts[item],
    }));    
  };

  const handleRemoveFile = (file) => {
    const filteredFiles = files?.filter(i => i.name !== file.name);
    setFiles(filteredFiles);
  };

  const validateFields = (step) => {
    let tempErrors = {};
    if(step === 0){
      if (!jobsite.jobsiteName) tempErrors.jobsiteName = 'Jobsite Name is required';
      if (!jobsite.jobsiteType) tempErrors.jobsiteType = 'Jobsite Type is required';
      if (!jobsite.street1 && !jobsite?.billingAddress) tempErrors.street1 = 'Street 1 is required';
      if (!jobsite.city && !jobsite?.billingAddress) tempErrors.city = 'City is required';
      if (!jobsite.state && !jobsite?.billingAddress) tempErrors.state = 'State is required';
      if (!jobsite.zipCode && !jobsite?.billingAddress) tempErrors.zipCode = 'Zip code is required';
    }
    setErrors(tempErrors);    
    return Object.keys(tempErrors).length === 0;
  };  

  const handleClearContactSearch = () => {
    handleContactSearchChange("");
  };

  const handleContactSearchChange = (searchKeyWord) => {
    setSearchContactText(searchKeyWord);
  };

  const handleClearPropAreaSearch = () => {
    handlePropAreaSearchChange("");
  };

  const handlePropAreaSearchChange = (searchKeyWord) => {
    setSearchPropAreaText(searchKeyWord);
  };

  // Content functions for each tab (same as step content but without step parameter)
  const getJobsiteDetailsContent = () => {
    return (
      <Fragment>            
        <Grid container spacing={5} my={3} mx={4}>
          <Grid item xs={12} sm={6}>
            <CustomTextField
              fullWidth
              label="Jobsite Name"
              required
              placeholder="Enter Jobsite Name"
              value={jobsite?.jobsiteName}
              onChange={(e) => handleJobsiteChange('jobsiteName', e.target.value)}
              error={!!errors.jobsiteName} 
              helperText={errors.jobsiteName}
            />
          </Grid>            
          <Grid item xs={12} sm={6}>
            <FormControl>
              <FormLabel                  
               required
                sx={{
                  "& .MuiFormLabel-asterisk": {
                    color: theme.palette.error.main,
                  },
                  fontSize: "13px",
                  color: theme.palette.mode === 'dark' ? 'rgba(208, 212, 241, 0.78) !important' : "rgba(47, 43, 61, 0.78)!important",
                }}
              >
                Jobsite Type
              </FormLabel>
              <RadioGroup row 
              name="jobsite-type-radio"
              value={jobsite?.jobsiteType}
              onChange={(e) => handleJobsiteChange('jobsiteType', e.target.value)}
              error={!!errors.jobsiteType} 
              helperText={errors.jobsiteType}
              >
                <FormControlLabel
                  value="Residential"
                  control={<Radio color="success" />}
                  label="Residential"
                />
                <FormControlLabel
                  value="Commercial"
                  control={<Radio color="success" />}
                  label="Commercial"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={10}>
            <FormLabel
              required
              sx={{
                "& .MuiFormLabel-asterisk": {
                  color: theme.palette.error.main,
                },
                fontSize: "13px",
                color: theme.palette.mode === 'dark' ? 'rgba(208, 212, 241, 0.78) !important' : "rgba(47, 43, 61, 0.78)!important",
                display: "block",
              }}
            >
              Jobsite Address
            </FormLabel>
             <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: { xs: 2, sm: 0 },
                alignItems: { xs: "flex-start", sm: "center" }
              }}>
            <FormControlLabel
              label="Use Primary Address as Jobsite Address"
              control={<Checkbox color="success" name="basic-unchecked"
                checked={jobsite?.billingAddress} 
                onChange={(e) => handleJobsiteChange('billingAddress', e.target.checked)}
              />}
            />
            </Box>
            </Grid>
             <Grid item xs={12} sm={10}>
            <CustomTextField fullWidth placeholder="Street 1" 
              value={jobsite?.billingAddress ? customer.companyAddress_Street1 : jobsite?.street1}
              onChange={(e) =>  jobsite?.billingAddress ? '' : handleJobsiteChange('street1', e.target.value)}
              disabled = {jobsite?.billingAddress}
              error={!!errors.street1} 
              helperText={errors.street1}
             />
             </Grid>
          <Grid item xs={12} sm={10}>
            <CustomTextField fullWidth placeholder="Street 2 (Optional)" 
            value={jobsite?.billingAddress? customer.companyAddress_Street2 : jobsite?.street2}
            onChange={(e) => jobsite?.billingAddress ? '' : handleJobsiteChange('street2', e.target.value)}
            disabled = {jobsite?.billingAddress}
            />
          </Grid>
          <Grid item xs={12} sm={10}>
            <CustomTextField fullWidth placeholder="Floor/Level (Optional)" 
            value={jobsite?.billingAddress? customer.companyAddress_FloorLevel : jobsite?.floorLevel}
            onChange={(e) => jobsite?.billingAddress ? '' : handleJobsiteChange('floorLevel', e.target.value)}
            disabled = {jobsite?.billingAddress}
            />
          </Grid>
          {/* <Grid item xs={12} sm={5}>
            <CustomTextField fullWidth placeholder="Unit Number (Optional)"
            value={jobsite?.billingAddress? customer.companyAddress_UnitNumber : jobsite?.unitNumber}
            onChange={(e) => jobsite?.billingAddress ? '' : handleJobsiteChange('unitNumber', e.target.value)}
            disabled = {jobsite?.billingAddress}
            />
          </Grid> */}
          <Grid item xs={12} sm={5}>
            <CustomTextField fullWidth placeholder="City"
            value={jobsite?.billingAddress? customer.companyAddress_City : jobsite?.city}
            onChange={(e) => jobsite?.billingAddress ? '' : handleJobsiteChange('city', e.target.value)}
            disabled = {jobsite?.billingAddress}
            error={!!errors.city} 
            helperText={errors.city}
            />
          </Grid>
        <Grid item xs={12} sm={5}>
<CustomAutocomplete
  required
  options={stateNames}
  id="autocomplete-custom"
  value={
    jobsite?.billingAddress
      ? stateNames.find((option) => option === customer?.companyAddress_State) || null
      : stateNames.find((option) => option === jobsite?.state) || null
  }
  onInputChange={(event, newInputValue) => {
    if (!jobsite?.billingAddress) {
      const expandedValue = expandStateName(newInputValue);
      handleJobsiteChange("state", expandedValue);
    }
  }}
  onChange={(event, newValue) => {
    if (!jobsite?.billingAddress) {
      handleJobsiteChange("state", newValue);
    }
  }}
  getOptionLabel={(option) => option || ""}
  renderInput={(params) => (
    <CustomTextField
      {...params}
      fullWidth
      placeholder="State"
      disabled={jobsite?.billingAddress}
    />
  )}
  sx={{
    "& .MuiInputBase-root": !!errors.state
      ? { borderColor: "error.main" }
      : {},
  }}
  disabled={jobsite?.billingAddress}
/>
<FormHelperText sx={{ fontSize: "13px", color: "error.main" }}>
  {errors.state}
</FormHelperText>
</Grid>
          <Grid item xs={12} sm={5}>
            <CustomTextField fullWidth placeholder="Zip code"
            value={jobsite?.billingAddress? customer.companyAddress_ZipCode : jobsite?.zipCode}
            onChange={(e) => jobsite?.billingAddress ? '' : handleJobsiteChange('zipCode', e.target.value)}
            disabled = {jobsite?.billingAddress}
            error={!!errors.zipCode} 
            helperText={errors.zipCode}
            />
          </Grid>
          <Grid item xs={12} sm={5}>
            <CustomTextField fullWidth placeholder="County" 
            value={jobsite?.billingAddress? customer.companyAddress_County : jobsite?.county}
            onChange={(e) => jobsite?.billingAddress ? '' : handleJobsiteChange('county', e.target.value)}
            disabled = {jobsite?.billingAddress}
            />
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <FormLabel>
                Upload Attachments
              </FormLabel>
              <IconButton sx={{ border: "1px solid #D9D9D9" }} size="small" onClick = {handleOpenUploadDlg}>
                <AddIcon />
              </IconButton>                  
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                flexWrap: 'wrap',
                gap: 5,
              }}
            >
              {files.length !== 0 && ( 
                files.map(file => (
                  <ListItem key={file.name} sx={{display:'flex', justifyContent: 'space-between', marginTop:'5px',width: '50%', boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px', borderRadius:'10px'}}>
                    <Box className='file-details' sx={{display:'flex', gap: 2}} >
                      <Box className='file-preview' sx={{display:'flex', gap: 2, textAlign:'center'}}>
                          {renderFilePreview(file.name)}
                          <Box sx={{display:'flex', flexDirection:'column', mx: 2}}>
                              <Tooltip title={file.name}>
                                <Typography 
                                  className='file-name' 
                                  whiteSpace='nowrap' 
                                  overflow='hidden'
                                >
                                  {file.name}
                                </Typography>
                              </Tooltip>
                              <Typography className='file-size' variant='body2'>
                                  {Math.round(file.size / 100) / 10 > 1000
                                  ? `${(Math.round(file.size / 100) / 10000).toFixed(1)} mb`
                                  : `${(Math.round(file.size / 100) / 10).toFixed(1)} kb`}
                              </Typography> 
                          </Box>                     
                      </Box>            
                    </Box>
                    <IconButton onClick={() => handleRemoveFile(file)}>
                      <Icon icon='tabler:x' fontSize={20} />
                    </IconButton>
                  </ListItem>
                ))
              )}
            </Box>
          </Grid>
        </Grid>
      </Fragment>
    );
  };

  const getJobsiteContactsContent = () => {
    const checkedCount = Object.values(checkedContacts).filter(Boolean).length;
    
    return (
      <Fragment>
        <Grid container spacing={5} my={3} mx={4}>
          <Grid item xs={12}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 4 }}>
              <AvatarGroup className="pull-up">
                {contacts
                  .filter((person) => checkedContacts[person.id])
                  .map((person) => (
                    <Tooltip title={`${person.firstName || ''} ${person.lastName || ''}`} key={person.id}>
                      <CustomAvatar
                        sx={{
                          height: 30,
                          width: 30,
                          fontSize: "12px",
                          position: "relative",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          "&:hover .initials": {
                            opacity: 0.3,
                          },
                          "&:hover::before": {
                            content: '"X"',
                            position: "absolute",
                            inset: 0,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontSize: "16px",
                            fontWeight: "bold",
                          },
                        }}
                        color={person.color}
                        onClick={() => handleAvatarClick(person.id)}
                      >
                        <span className="initials">{person.initials}</span>
                      </CustomAvatar>
                    </Tooltip>
                  ))}
              </AvatarGroup>
              {checkedCount > 0 && (
                <Typography
                  variant="body1"
                  sx={{ fontWeight: "550", color: "text.secondary" }}
                >
                  {checkedCount} {checkedCount > 1 ? "contacts" : "contact"}{" "}
                  selected
                </Typography>
              )}                 
              {checkedCount > 0 && (
                <Tooltip title='Remove Selected'>
                  <IconButton onClick={() => handleContactDelete()}>
                    <Icon icon='tabler:x' fontSize={20}/>
                  </IconButton>
                </Tooltip>
              )}
            </Box> 
          </Grid>
         <Grid
  item
  xs={12}
  sx={{
    display: "flex",
    alignItems: { xs: "stretch", sm: "center" },
    justifyContent: { xs: "flex-start", sm: "space-between" },
    flexDirection: { xs: "column", sm: "row" },
    gap: { xs: 2, sm: 0 },
  }}
>
  <CustomTextField
    placeholder="Search Contact"
    fullWidth
    value={searchContactText}
    onChange={(e) => handleContactSearchChange(e.target.value)}
    sx={{ maxWidth: { xs: "100%", sm: "550px" } }}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <Icon icon="tabler:search" />
        </InputAdornment>
      ),
      endAdornment: (
        <InputAdornment position="end">
          {searchContactText && (
            <IconButton
              edge="end"
              onClick={handleClearContactSearch}
              aria-label="clear"
              sx={{ mr: 2 }}
            >
              <ClearIcon />
            </IconButton>
          )}
        </InputAdornment>
      ),
    }}
  />
  <Typography
    sx={{
      textAlign: { xs: "center", sm: "initial" },
    }}
  >
    or
  </Typography>
  <Button
    variant="contained"
    color="main"
    startIcon={<AddIcon />}
    onClick={handleOpenNewContactDlg}
    sx={{ width: { xs: "100%", sm: "auto" } }}
  >
    Create Contact
  </Button>
</Grid>

          <Grid item xs={12}>
            <Typography variant="h6" color='text.secondary'>
              Select Contacts for this Jobsite
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', color: 'info.main', gap: 1, mt: 2 }}>
              <Icon icon='tabler:info-circle' size='small' />
              <Typography variant='body2' color='text.secondary'>
                The selected contact(s) will receive communication regarding this specific Jobsite.
              </Typography>
            </Box>
            <List>
            {contacts && contacts.length > 0 ? (
              contacts
              .filter(row =>    
                  Object.values(row).some(value =>
                      value && value.toString().toLowerCase().includes(searchContactText.toLowerCase())
                  )
              )
              .map((person) => (
                <ListItem key={person.id}>
                  <ListItemIcon>
                    <Checkbox
                      edge="start"
                      color="success"
                      checked={!!checkedContacts[person.id]}
                      onChange={() => handleToggleContacts(person.id)}
                    />
                  </ListItemIcon>
                  <ListItemIcon>
                    <CustomAvatar
                      sx={{ height: 30, width: 30, fontSize: "12px" }}
                      color={person.color}
                    >
                      {person.initials}
                    </CustomAvatar>
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography color={theme.palette.mode === 'dark' ? "secondary" : "primary"} sx={{ mr: 2 }}>
                        {`${person.firstName || ''} ${person.lastName || ''}`}
                        </Typography>
                        <Typography color="text.secondary">
                          ({person.jobTitle})
                        </Typography>
                      </Box>
                    }
                  />
                </ListItem>
              ))) : (
                <Typography>No contacts available.</Typography>
              )}
            </List>
          </Grid>
        </Grid>
      </Fragment>
    );
  };

  const getPropertyAreasContent = () => {
    if (!hasPropertyAreaSavePermission) return null;
    
    return (
      <Fragment>
        <Grid container spacing={5} my={3} mx={4} sx={{ pointerEvents: !hasPropertyAreaSavePermission ? 'none' : 'default'}}>
          <Grid item xs={12}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Typography variant="h5" fontWeight="bold">
                Property Areas ({propertyAreaList?.length || 0})
              </Typography>
              <IconButton
                sx={{ border: "1px solid #D9D9D9" }}
                size="small"
                disabled={!hasPropertyAreaSavePermission}
                {...(hasPropertyAreaSavePermission && {
                  onClick: () => handleOpenNewPropertyDlg()
                })}
              >
                <AddIcon />
              </IconButton>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <CustomTextField
              placeholder="Search"
              fullWidth
              value={searchPropAreaText}
              onChange={(e) => handlePropAreaSearchChange(e.target.value)} 
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Icon icon="tabler:search" />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    {searchPropAreaText && (
                      <IconButton
                        edge="end"
                        onClick={handleClearPropAreaSearch}
                        aria-label="clear"
                        sx={{mr: 2}}
                      >
                        <ClearIcon />
                      </IconButton>
                    )}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12}>               
            {propertyAreaList.length > 0 ? (
              <>
                <Typography variant="h6" color="text.secondary">
                  OUTDOOR AREAS ({Outdoor?.length})
                </Typography>
                <List component="nav" aria-label="main mailbox">
                  {Outdoor && Outdoor.length > 0 ? 
                  Outdoor
                  .filter(row =>    
                      Object.values(row).some(value =>
                          value && value.toString().toLowerCase().includes(searchPropAreaText.toLowerCase())
                      )
                  )
                  .map((property, index)=>(
                    <>
                      <ListItem
                      key={index}
                      disablePadding
                      sx={{ borderBottom: "1px solid #E1E4EA" }}
                    >
                      <ListItemButton onClick={() => handleClickPropAreaOutdoor(index,openPropAreaOutdoor[index])}>
                        <Icon
                          icon={
                            openPropAreaOutdoor[index]
                              ? "tabler:chevron-up"
                              : "tabler:chevron-down"
                          }
                        />
                        <ListItemText sx={{ ml: 4 }} primary={property.propertyAreaName} />
                      </ListItemButton>
                      <IconButton onClick={()=>handleEditPropertyArea(property.propertyAreaID)}>
                        <Icon icon="tabler:pencil" />
                      </IconButton>
                      <IconButton color="error" onClick={()=>handleDeletePropertyArea(property.propertyAreaID, property.jobsiteID)}>
                        <Icon icon="tabler:trash" />
                      </IconButton>
                      </ListItem>
                      <Collapse in={openPropAreaOutdoor[index]} timeout="auto" unmountOnExit>
                        <Grid container spacing={2} my={4}>
                          <Grid item xs={12} sm={4}>
                            <Typography variant="body1" color="text.secondary">
                              Property Name
                            </Typography>
                          </Grid>
                          <Grid item xs={12} sm={8}>
                            <Typography variant="body1">{property?.propertyAreaName}</Typography>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <Typography variant="body1" color="text.secondary">
                              Property Type
                            </Typography>
                          </Grid>
                          <Grid item xs={12} sm={8}>
                            <Typography variant="body1">{property?.propertyAreaType}</Typography>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <Typography variant="body1" color="text.secondary">
                              Description
                            </Typography>
                          </Grid>
                          <Grid item xs={12} sm={8}>
                            <Typography variant="body1">
                              {property?.description}
                            </Typography>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <Typography variant="body1" color="text.secondary">
                              Area Measurements
                            </Typography>
                          </Grid>                              
                            <Grid item xs={12} sm={8}>                                  
                              {property?.measurement && property?.measurement.map((measure, index)=>(
                                <Box
                                key={index}
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  borderBottom: "1px solid #E1E4EA",
                                  pb: 2,
                                }}
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 2,
                                    }}
                                  >
                                    <Icon icon="tabler:ruler-measure-2" />
                                    <Typography variant="subtitle1">
                                      {measure?.measurementName}
                                    </Typography>
                                  </Box>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 2,
                                    }}
                                  >
                                    <Typography variant="subtitle2">
                                      Total size
                                    </Typography>
                                    <CustomChip
                                      skin="light"
                                      color="primary"
                                      label={`${measure.total} ${measure.unitOfMeasure}`}
                                      sx={{ fontWeight: "550" }}
                                    />
                                  </Box>
                                </Box>
                              ))}                                                                 
                            </Grid>                                                            
                        </Grid>
                      </Collapse>
                    </>
                  )):(
                    <Typography variant="h6" color="text.secondary" mt={4}>
                      No Outdoor Property Area found.
                    </Typography>
                  )}                      
                </List>
                <Typography variant="h6" color="text.secondary" mt={4}>
                  INDOOR AREAS ({Indoor?.length})
                </Typography>
                <List component="nav" aria-label="main mailbox">
                  {Indoor && Indoor.length > 0 ? 
                  Indoor
                  .filter(row =>    
                    Object.values(row).some(value =>
                        value && value.toString().toLowerCase().includes(searchPropAreaText.toLowerCase())
                    )
                  )
                  .map((property, index)=>(
                    <>
                      <ListItem
                      key={index}
                      disablePadding
                      sx={{ borderBottom: "1px solid #E1E4EA" }}
                    >
                      <ListItemButton onClick={() => handleClickPropArea(index,openPropArea[index])}>
                        <Icon
                          icon={
                            openPropArea[index]
                              ? "tabler:chevron-up"
                              : "tabler:chevron-down"
                          }
                        />
                        <ListItemText sx={{ ml: 4 }} primary={property.propertyAreaName} />
                      </ListItemButton>
                      <IconButton onClick={()=>handleEditPropertyArea(property.propertyAreaID)}>
                        <Icon icon="tabler:pencil" />
                      </IconButton>
                      <IconButton color="error" onClick={()=>handleDeletePropertyArea(property.propertyAreaID, property.jobsiteID)}>
                        <Icon icon="tabler:trash" />
                      </IconButton>
                      </ListItem>
                      <Collapse in={openPropArea[index]} timeout="auto" unmountOnExit>
                        <Grid container spacing={2} my={4}>
                          <Grid item xs={12} sm={4}>
                            <Typography variant="body1" color="text.secondary">
                              Property Name
                            </Typography>
                          </Grid>
                          <Grid item xs={12} sm={8}>
                            <Typography variant="body1">{property?.propertyAreaName}</Typography>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <Typography variant="body1" color="text.secondary">
                              Property Type
                            </Typography>
                          </Grid>
                          <Grid item xs={12} sm={8}>
                            <Typography variant="body1">{property?.propertyAreaType}</Typography>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <Typography variant="body1" color="text.secondary">
                              Description
                            </Typography>
                          </Grid>
                          <Grid item xs={12} sm={8}>
                            <Typography variant="body1">
                              {property?.description}
                            </Typography>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <Typography variant="body1" color="text.secondary">
                              Area Measurements
                            </Typography>
                          </Grid>                              
                            <Grid item xs={12} sm={8}>
                              {property?.measurement && property?.measurement.map((measure, index)=>(
                                <Box
                                key={index}
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  borderBottom: "1px solid #E1E4EA",
                                  pb: 2,
                                }}
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 2,
                                    }}
                                  >
                                    <Icon icon="tabler:ruler-measure-2" />
                                    <Typography variant="subtitle1">
                                      {measure?.measurementName}
                                    </Typography>
                                  </Box>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 2,
                                    }}
                                  >
                                    <Typography variant="subtitle2">
                                      Total size
                                    </Typography>
                                    <CustomChip
                                      skin="light"
                                      color="primary"
                                      label={`${measure.total} ${measure.unitOfMeasure}`}
                                      sx={{ fontWeight: "550" }}
                                    />
                                  </Box>
                                </Box>
                              ))}                                                                 
                            </Grid>                                                            
                        </Grid>
                      </Collapse>
                    </>
                  )):(
                    <Typography variant="h6" color="text.secondary" mt={4}>
                      No Indoor Property Area found.
                    </Typography>
                  )}
                </List>
              </>
            ): 
            (
             
                <Box
  sx={{
    display: "flex",
    justifyContent: "center",
    mx: "auto",
    border: "1px solid #EAEAEA",
    borderRadius: 1,
    maxWidth: "100%",
    width: "100%",
    height: { xs: "auto", sm: 280 },
    minHeight: { xs: 180, sm: 280 },
    py: { xs: 3, sm: 4 },
    px: { xs: 2, sm: 0 },
    boxSizing: "border-box",
    overflow: "hidden",
  }}
>
  <Box
    sx={{ 
      display: "flex", 
      flexDirection: "column", 
      gap: { xs: 1.5, sm: 2 },
      justifyContent: "center", 
      alignItems: "center",
      width: "100%",
      maxWidth: "90%",
      textAlign: "center",
      px: { xs: 1, sm: 0 },
    }}
  >
                     <img 
      src={AddEmployeeDoodle} 
      alt="Empty State"  
      style={{ 
        width: '80px',
        height: 'auto',
        [theme.breakpoints.up('sm')]: {
          width: '100px'
        }
      }}
    />
                    <Typography variant="h6">No property area added yet</Typography>
                     <Button
                        variant="contained"
                        color="main"
                         startIcon={<AddIcon />}
                        sx={{ mt: 4 }}
                        disabled={!hasPropertyAreaSavePermission}
                        {...(hasPropertyAreaSavePermission && {
                          onClick: () => handleOpenNewPropertyDlg()
                        })}
                      >
                        Create Property Area
                      </Button>
                  </Box>
                </Box>
                     
                   
            )                
          }
          </Grid>
        </Grid>
      </Fragment>
    );
  };

  const getJobsiteAlertsContent = () => {
    if (!hasAlertSavePermission) return null;
    
    return (
      <Fragment>
        <Grid container spacing={5} my={3} mx={4} sx={{ pointerEvents: !hasAlertSavePermission ? 'none' : 'default'}}>
          <Grid item xs={12}>
            <Typography variant="h5">Jobsite Alerts</Typography>
            <Typography variant="body2" mt={2}>
              These alerts will appear for field crew everytime they arrive
              at the jobsite.
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <CustomTextField                  
              fullWidth
              disabled={!hasAlertSavePermission}
              placeholder="Type alert message (e.g., Safety precaution required)..."
              value= {alert.alertDescription}
              {...(hasAlertSavePermission && {
                onChange: (e) => handleAlertChange('alertDescription', e.target.value)
              })}
              error={!!alertErrors.alertDescription} 
              helperText={alertErrors.alertDescription}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="main"
              sx={{ float: "right" }}
              disabled={!hasAlertSavePermission}
              {...(hasAlertSavePermission && {
                onClick: ()=> handleSaveAlert()
              })}
            >
              Create Alert
            </Button>
          </Grid>
          {hasAlertGetPermission && (
            <>
              <Grid item xs={12}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Icon
                    icon="tabler:circle-filled"
                    fontSize="13px"
                    color={theme.palette.success.main}
                  />
                  <Typography variant="h6" color="text.secondary">
                    ACTIVE ALERTS ({activeAlerts.length})
                  </Typography>
                </Box>
              </Grid>
              {activeAlerts && activeAlerts.length > 0 ? 
                activeAlerts.map((Alert, index)=>(
                <Grid key={index} item xs={12}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      justifyContent: "space-between",
                      backgroundColor: theme.palette.mode === 'dark' ? '#1B2431' : '#F5F7FA',
                      px: 4,
                      borderRadius: 1,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography variant="subtitle2">
                      {Alert.alertDescription}
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Checkbox 
                        color="success" 
                        sx={{ mr: 2 }} 
                        checked={!!Alert.isActive}
                        onChange={() => handleAlertEdit(Alert.alertID)}                        
                        />
                      <IconButton color="error" onClick={()=>{handleAlertDelete(Alert.alertID, Alert.jobsiteID)}}>
                        <Icon icon="tabler:trash" size="small" />
                      </IconButton>
                    </Box>
                  </Box>
                </Grid>
                )):(
                  <Grid item xs={12}>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 2,
                            justifyContent: "space-between",
                            backgroundColor: theme.palette.mode === 'dark' ? '#1B2431' : '#F5F7FA',
                            borderColor: 'rgba(208, 212, 241, 0.2)',
                            p: 4,
                            borderRadius: 1,
                        }}                                
                    >
                      <Typography variant="subtitle2">
                        No active alerts found.
                      </Typography>          
                    </Box>
                  </Grid>
                )}
              
              <Grid item xs={12}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Icon
                    icon="tabler:circle-filled"
                    fontSize="13px"
                    color={theme.palette.secondary.main}
                  />
                  <Typography variant="h6" color="text.secondary">
                    INACTIVE ALERTS ({inactiveAlerts.length})
                  </Typography>
                </Box>
              </Grid>
              {inactiveAlerts && inactiveAlerts.length > 0 ? 
                inactiveAlerts.map((Alert, index)=>(
                <Grid key={index} item xs={12}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      justifyContent: "space-between",
                      backgroundColor: theme.palette.mode === 'dark' ? '#1B2431' : '#F5F7FA',
                      px: 4,
                      borderRadius: 1,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography variant="subtitle2">
                      {Alert.alertDescription}
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Checkbox color="success" sx={{ mr: 2 }} 
                      checked={!!Alert.isActive}
                      onChange={() => handleAlertEdit(Alert.alertID)}
                      />
                      <IconButton color="error" onClick={()=>{handleAlertDelete(Alert.alertID, Alert.jobsiteID)}}>
                        <Icon icon="tabler:trash" size="small" />
                      </IconButton>
                    </Box>
                  </Box>
                </Grid>
                )):(
                  <Grid item xs={12}>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 2,
                            justifyContent: "space-between",
                            backgroundColor: theme.palette.mode === 'dark' ? '#1B2431' : '#F5F7FA',
                            borderColor: 'rgba(208, 212, 241, 0.2)',
                            p: 4,
                            borderRadius: 1
                        }}                                
                    >
                      <Typography variant="subtitle2">
                        No inactive alerts found.
                      </Typography>          
                    </Box>
                  </Grid>
                )}
            </>
          )}
        </Grid>
      </Fragment>
    );
  };

  // Render stepper for create/edit mode, tabs for tabbed mode
  const renderHeader = () => {
    if (jobsiteContent.mode === 'tabbed') {
      return (
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs 
            value={tabValue} 
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
          >
            {tabs.map((tab) => (
              <Tab 
                key={tab.value} 
                label={tab.label} 
                id={`jobsite-tab-${tab.value}`}
                aria-controls={`jobsite-tabpanel-${tab.value}`}
              />
            ))}
          </Tabs>
        </Box>
      );
    } else {
      return (
        <StepperHeaderContainer>
          <StepperWrapper>
            <Stepper
              activeStep={activeStep}
              connector={<></>}
              sx={{ gap: 4 }}
            >
              {steps.map((step, index) => {
                const RenderAvatar =
                  activeStep >= index ? CustomAvatar : Avatar;
                const isStepActive = activeStep === index;
                return (
                  <StepJobsite 
                    key={index} 
                    sx={{ 
                      paddingBottom: 0, 
                      "& .MuiStepLabel-label": { 
                        cursor: jobsiteContent.mode === 'edit' ? "pointer" : 'default'
                      } 
                    }}
                    onClick={() => jobsiteContent.mode === 'edit' && setActiveStep(index)}
                  >
                    <StepLabel>
                      <div className="step-label">
                        <RenderAvatar
                          variant="rounded"
                          {...(activeStep >= index && {
                            skin: "light",
                          })}
                          {...(isStepActive && { skin: "filled" })}
                          {...(activeStep >= index && {
                            color: "success",
                          })}
                          sx={{
                            ...(isStepActive && {
                              boxShadow: (theme) => theme.shadows[3],
                              color: "#fff",
                            }),
                            ...(activeStep > index && {
                              color: (theme) =>
                                hexToRGBA(theme.palette.primary.main, 0.4),
                            }),
                          }}
                        >
                          <Typography
                            variant="h4"
                            sx={{
                              color: isStepActive
                                ? "#fff"
                                : (theme) => theme.palette.primary.main,
                            }}
                          >
                            {index + 1}
                          </Typography>
                        </RenderAvatar>
                        <div>
                          <Typography
                            variant="subtitle2"
                            color="text.secondary"
                            {...(activeStep === index && {
                              fontWeight: "550",
                              color: "text.primary",
                            })}
                          >
                            {step.title}
                          </Typography>
                        </div>
                      </div>
                    </StepLabel>
                  </StepJobsite>
                );
              })}
            </Stepper>
          </StepperWrapper>
        </StepperHeaderContainer>
      );
    }
  };

  // Render content based on mode
 const renderContent = () => {
  if (jobsiteContent.mode === "tabbed") {
    return (
      <form onSubmit={(e) => e.preventDefault()}>
        <TabPanel
          value={tabValue}
          index={0}
          sx={{
            width: "100%", // ✅ prevent tab panel from expanding
            overflowX: "hidden",
            boxSizing: "border-box",
          }}
        >
          {getJobsiteDetailsContent()}
        </TabPanel>

        <TabPanel
          value={tabValue}
          index={1}
          sx={{
            width: "100%",
            overflowX: "hidden",
            boxSizing: "border-box",
          }}
        >
          {getJobsiteContactsContent()}
        </TabPanel>

        {hasPropertyAreaSavePermission && (
          <TabPanel
            value={tabValue}
            index={2}
            sx={{
              width: "100%",
              overflowX: "hidden",
              boxSizing: "border-box",
            }}
          >
            {getPropertyAreasContent()}
          </TabPanel>
        )}

        {hasAlertSavePermission && (
          <TabPanel
            value={tabValue}
            index={hasPropertyAreaSavePermission ? 3 : 2}
            sx={{
              width: "100%",
              overflowX: "hidden",
              boxSizing: "border-box",
            }}
          >
            {getJobsiteAlertsContent()}
          </TabPanel>
        )}
      </form>
    );
  } else {
    // Original stepper-based content
    const getStepContent = (step) => {
      if (step === 2 && !hasPropertyAreaSavePermission) return null;
      if (step === 3 && !hasAlertSavePermission) return null;

      switch (step) {
        case 0:
          return getJobsiteDetailsContent();
        case 1:
          return getJobsiteContactsContent();
        case 2:
          return getPropertyAreasContent();
        case 3:
          return getJobsiteAlertsContent();
        default:
          return "Unknown Step";
      }
    };

    return (
      <form onSubmit={(e) => e.preventDefault()}>
        <Grid container spacing={5}>
          {getStepContent(activeStep)}
        </Grid>
      </form>
    );
  }
};

const checkedCount = Object.values(checkedContacts).filter(Boolean).length;

return (
  <>
    <Dialog
      disableEscapeKeyDown
      fullWidth
      maxWidth="md"
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      PaperProps={{
        sx: {
          height: "100%",
          maxHeight:
            jobsiteContent.mode === "tabbed" ? "94vh" : "92vh",
          minHeight:
            jobsiteContent.mode === "tabbed" ? "600px" : "auto",
          overflowX: "hidden", 
        },
      }}
    >
      <DialogTitle>
        <Typography variant="h3" fontWeight="bold">
          {jobsiteContent?.title || "Edit Jobsite"}
        </Typography>
        {jobsiteContent?.customerName && (
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ mt: 0.5 }}
          >
            {jobsiteContent.customerName}
          </Typography>
        )}
      </DialogTitle>

    <DialogContent
  sx={{
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
    p: 0,
  }}
>
  {renderHeader()}

  {jobsiteContent.mode === "tabbed" ? (
    <Box
      sx={{
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        width: "100%",
        minWidth: 0,
        maxWidth: "100%",
      }}
    >
      <Box
        sx={{
          flexGrow: 1,
          overflowY: "auto",
          overflowX: "hidden",
          width: "100%",
          minWidth: 0,
          maxWidth: "100%",
          boxSizing: "border-box",
          px: 2, 
          "& .MuiTabPanel-root": {
            p: 0,
            width: "100%",
            minWidth: 0,
            maxWidth: "100%",
            boxSizing: "border-box",
            overflowX: "hidden", 
          },
          "& .MuiGrid-container": {
            width: "100%",
            maxWidth: "100%",
            m: 0,
          },
          "& .MuiBox-root": {
            maxWidth: "100%",
            minWidth: 0,
            boxSizing: "border-box",
          },
        }}
      >
        {renderContent()}
      </Box>
    </Box>
  ) : (
    <Box>{renderContent()}</Box>
  )}
</DialogContent>



     <DialogActions
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: { xs: "column", sm: "row" },
            gap: { xs: 2, sm: 0 },
            alignItems: { xs: "center", sm: "center" },
          }}
          className="dialog-actions-dense"
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              width: { xs: "100%", sm: "auto" },
              gap: { xs: 2, sm: 0 },
            }}
          >
            <Button
              variant="contained"
              color="info"
              onClick={handleClose}
              sx={{ width: { xs: "100%", sm: "auto" } }}
            >
              Cancel
            </Button>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              width: { xs: "100%", sm: "auto" },
              gap: { xs: 2, sm: 0 },
            }}
          >
           
            {jobsiteContent.mode === "tabbed" && (
              <Button
                variant="contained"
                color="main"
                onClick={handleSaveJobSite}
                sx={{ width: { xs: "100%", sm: "auto" } }}
              >
                Save Changes
              </Button>
            )}

            {/* For stepper modes */}
            {jobsiteContent.mode !== "tabbed" && (
              <>
                <Button
                  variant="outlined"
                  color="main"
                  disabled={activeStep === 0}
                  onClick={handleBack}
                  sx={{ width: { xs: "100%", sm: "auto" } }}
                >
                  Back
                </Button>

                {jobsiteContent.mode === "edit" && (
                  <>
                    <Button
                      variant="outlined"
                      color="main"
                      onClick={handleNext}
                      disabled={activeStep === steps.length - 1}
                      sx={{ width: { xs: "100%", sm: "auto" }, ml: { sm: 5, xs: 0 } }}
                    >
                      Next
                    </Button>
                    <Button
                      variant="contained"
                      color="main"
                      onClick={handleSaveJobSite}
                      sx={{ width: { xs: "100%", sm: "auto" }, ml: { sm: 5, xs: 0 } }}
                    >
                      Save Changes
                    </Button>
                  </>
                )}

                {jobsiteContent.mode === "create" && (
                  <Button
                    variant="contained"
                    color="main"
                    onClick={handleNext}
                    sx={{ width: { xs: "100%", sm: "auto" }, ml: { sm: 5, xs: 0 } }}
                  >
                    {activeStep === steps.length - 1 ? "Save Jobsite" : "Save & Next"}
                  </Button>
                )}
              </>
            )}
          </Box>
        </DialogActions>
    </Dialog>


      
      {/* Rest of your dialog components remain the same */}
      <JobsiteAttachment
        open={openUploadDlg}   
        setOpen={setOpenUploadDlg}             
        handleClose={handleCloseUploadDlg}  
        Title="Upload Attachment"
        files = {uploadFiles}
        setFiles = {setUploadFiles}
        sf = {setFiles}        
        customer = {customer}      
      />  
      <AddContactDialog 
        open={openNewContactDlg}
        handleClose={handleCloseNewContactDlg}
        customer = {customer}
        fetchContactData = {fetchContacts}   
        toast = {toast}            
        setLoading={setLoading}          
      />  
      <AddPropertyAreaDialog
        propertyContent = {propertyContent}
        open={openNewPropertyDlg}
        handleClose={handleCloseNewPropertyDlg}
        jobsite = {jobsite}
        propertyArea = {propertyArea}
        setPropertyArea = {setPropertyArea}
        areaMeasurement = {areaMeasurement}
        setAreaMeasurement = {setAreaMeasurement} 
        clearAreaMeasurement= {clearAreaMeasurement}  
        navigate = {navigate}  
        toast = {toast}   
        setLoading = {setLoading}
        fetchPropertyArea = {fetchPropertyArea}
        listOfMeasurements = {listOfMeasurements}
        setListOfMeasurements = {setListOfMeasurements}
        clearPropertyArea = {clearPropertyArea}
        />
    </>
  );
};

export default AddJobsiteDialog;